import { CartAffiliate } from '@/api/Cart/cart.interfaces';
import store from '@/store';
import { isChannelMetaFlight } from '@/helpers/affiliate';
import { CartProductCombination } from '@shared/interfaces/productCombination';
import { isStatsigPreselectBaggageByDefault } from '@/tracking/statsig/experiment.functions';

export const preselectBaggageByDefault = () => {
    const affiliate: CartAffiliate = store.getters['cart/getAffiliate'];
    const productCombination: CartProductCombination =
        store.getters['cart/getProductCombination'];
    if (isChannelMetaFlight(affiliate) || !productCombination.Includes.Flight) {
        return false;
    }
    return isStatsigPreselectBaggageByDefault();
};
